// extracted by mini-css-extract-plugin
export default {"cls1":"nrZZhc4ZnvDPTK7eE9A_","cls2":"IyzKXxj4fIMDyHNdFKn5 nrZZhc4ZnvDPTK7eE9A_"};